import { z } from 'zod'

const providerToolSchema = z.object({
  slug: z.string(),
  name: z.string().optional(),
  description: z.string().optional(),
}).passthrough()

const previewSchema = z.object({
  toolkit: z.string(),
  tools: z.array(providerToolSchema),
  scopes_required: z.array(z.string()).optional(),
  per_tool_requirements: z.array(z.unknown()).optional(),
}).passthrough()

const groupSchema = z.object({
  id: z.string().optional(),
  toolkit_slug: z.string(),
  preview: previewSchema,
  rationale: z.string().nullable().optional(),
  status: z.string().optional(),
  connection_status: z.string().optional(),
}).passthrough()

export const integrationAccessRequestCardSchema = z.object({
  kind: z.literal('integration_access_request'),
  review_id: z.string(),
  assistant_message_id: z.string(),
  groups: z.array(groupSchema),
  status: z.string().optional(),
}).passthrough()
